export default __webpack_public_path__ + "static/stile-x-37986d671b86276a89a4be81059df2eb.jpg";